module.exports = __webpack_public_path__ + "4afa668a1e12007469d56d43a04849c3.png";